import { createStore } from 'satcheljs';
export default createStore('popOption', {
    popEnabled: null,
    popMessageDeleteEnabled: null,
    popSettings: null,
    imapSettings: null,
    smtpSettings: null,
})();
//# sourceMappingURL=store.js.map